var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axiosRetry from 'axios-retry';
import createError from 'axios/lib/core/createError';
var namespace = 'retry';
var enhancer = function (instance, config) {
    if (config === void 0) { config = {}; }
    instance.interceptors.response.use(function (response) {
        var _a, _b;
        var data = response.data, config = response.config, request = response.request;
        if ((_b = (_a = config === null || config === void 0 ? void 0 : config[namespace]) === null || _a === void 0 ? void 0 : _a.shouldRetry) === null || _b === void 0 ? void 0 : _b.call(_a, data)) {
            config[namespace].needRetry = true;
            return Promise.reject(createError("Axios retry enhance error", config, null, request, response));
        }
        return response;
    });
    axiosRetry(instance, __assign(__assign({}, config), { retryCondition: function (error) {
            var _a, _b;
            var _c = config.retryCondition, retryCondition = _c === void 0 ? axiosRetry.isNetworkOrIdempotentRequestError : _c;
            return retryCondition(error) || ((_b = (_a = error.config) === null || _a === void 0 ? void 0 : _a[namespace]) === null || _b === void 0 ? void 0 : _b.needRetry);
        } }));
};
export default enhancer;
